import * as React from 'react';

import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@rtkwlf/fenrir-react';

import { spidrStateToBadge } from '../constants/spidr-state-to-appearance';
import { useSecurityJourneyTranslations } from '../locales/use-security-journey-translations';

import styles from './spidr-state-badge.module.css';

/* -------------------------------------------------------------------------------------------------
 * SpidrStateBadge
 * -----------------------------------------------------------------------------------------------*/
export type SpidrStateBadgeProps = {
  state: keyof typeof spidrStateToBadge;
};

export const SpidrStateBadge: React.FunctionComponent<SpidrStateBadgeProps> = (
  props,
) => {
  const { t } = useSecurityJourneyTranslations();

  return (
    <Badge.Root
      className={styles['spidr-state-badge']}
      data-testid="spidr-details-state-badge"
      appearance={spidrStateToBadge[props.state].appearance}
    >
      <Badge.Icon marginRight="xsmall">
        <FontAwesomeIcon
          icon={
            spidrStateToBadge[props.state].icon as FontAwesomeIconProps['icon']
          }
        />
      </Badge.Icon>
      <Badge.Text>{t(spidrStateToBadge[props.state].text)}</Badge.Text>
    </Badge.Root>
  );
};
